import { CircularProgress, Grid } from '@mui/material'

export const LoaderComponent = () => {
  return (
    <Grid sx={{ display: "flex", justifyContent:"center", height:"100%"}}>
        <CircularProgress sx={{position:"relative", top:"40%"}}/>
    </Grid>
  )
}
